exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes _3KtSaEOkqjcSgjjx1Rrh1b{from{transform:translate3d(0, 1rem, 0);visibility:visible;opacity:0}to{transform:translate3d(0, 0, 0);opacity:1}}@keyframes _1HlrKEZjSCMIq9ssElc8o1{from{visibility:visible;opacity:0}to{opacity:1}}@keyframes _2Qz8IqGJuWmLvBzwOpZfvc{0%{filter:blur(3.125rem)}25%{filter:blur(1.25rem)}100%{filter:blur(0)}}._3by5zh05CQFGDQLWMRpqfm{font-family:MazdaTypeRegular, sans-serif;font-size:0.875rem;line-height:2.25rem}@media screen and (min-width: 768px){._3by5zh05CQFGDQLWMRpqfm{font-size:1rem;line-height:2.5rem}}._3Dr1BwWP0B0KxRUKfFMQ1R{margin-top:3rem}.UbnzzFS4xBjgnrHtvgoPg h3{font-family:MazdaTypeBold, sans-serif;font-size:.8125rem;line-height:1.5rem;text-transform:uppercase;letter-spacing:.11875rem}@media screen and (min-width: 768px){.UbnzzFS4xBjgnrHtvgoPg h3{font-size:.9375rem;line-height:1.5625rem;letter-spacing:.1875rem}}\n", ""]);

// exports
exports.locals = {
	"textBlock": "_3by5zh05CQFGDQLWMRpqfm",
	"topSpacing": "_3Dr1BwWP0B0KxRUKfFMQ1R",
	"dealerImprintText": "UbnzzFS4xBjgnrHtvgoPg",
	"slideinup": "_3KtSaEOkqjcSgjjx1Rrh1b",
	"fadeIn": "_1HlrKEZjSCMIq9ssElc8o1",
	"blur": "_2Qz8IqGJuWmLvBzwOpZfvc"
};